import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { SingleButton, TwinColumn } from "../../../assets/components/ButtonGroup";
import { SelectCard } from "../../../assets/components/SelectGroup";
import ChanneSelectSheet from "../../Ads/components/BottomSheet/ChannelSelectSheet";
import { HeaderIconLActionR } from "../../../assets/components/HeaderGroup";
import { Chip } from "../../../assets/components/Chip";
import arrowleft from "../../../assets/icons/Arrow/left.svg";
import { useToast } from "../../../hooks/useToast";
import Popup from "../../../assets/components/PopupGroup";
import checkOn from "../../../assets/icons/Select/check_checked.svg";
import checkOff from "../../../assets/icons/Select/check_unchecked.svg";
import Cafe from "../../../assets/image/bgExImage/cafe.png";
import Clothes from "../../../assets/image/bgExImage/clothes.png";
import Hair from "../../../assets/image/bgExImage/hair.png";
import Meat from "../../../assets/image/bgExImage/meat.png";
import BgPrompts from "./detailComponents/bgPrompts";
import vintage from "../../../assets/image/filter/0.jpg";
import two_d from "../../../assets/image/filter/2.jpg";
import refresh from "../../../assets/image/filter/3.jpg";

const channelMap = {
  "1": "카카오톡",
  "2": "인스타 스토리",
  "3": "인스타 게시물",
  "6": "네이버 밴드",
};

const ageMap = {
  "1": "10대",
  "2": "20대",
  "3": "30대",
  "4": "40대",
  "5": "50대",
  "6": "60대 이상",
};

const themeMap = {
  "1": "매장 홍보",
  "2": "상품 소개",
  "3": "이벤트",
};

const STYLE_OPTIONS = [
  "원본 사용",
  "배경 AI 변경",
  "이미지 필터",
  "AI 모델 합성",
];

const bgOptions = [
  { key: "cafe", label: "카페", image: Cafe },
  { key: "clothes", label: "의류 매장", image: Clothes },
  { key: "hair", label: "헤어샵", image: Hair },
  { key: "meat", label: "고깃집", image: Meat },
];

const fiOptions = [
  { key: 0, label: "레트로", image: vintage },
  { key: 2, label: "2D", image: two_d },
  { key: 3, label: "예술", image: refresh },
];

const defaultAiModel = {
  enabled: false,
  modelType: "",
  label: "",
  prompt: "",
};

const normalizeAiModel = (model) => {
  const merged = { ...defaultAiModel, ...(model || {}) };
  merged.enabled = Boolean(merged.enabled && merged.modelType);
  return merged;
};

const aiModelOptions = [
  {
    key: "ai_model_1",
    label: "AI 모델 1",
    prompt:
      "A natural-looking Asian female model with a bright, healthy smile, clear glowing skin, and long dark hair. She has a fresh and pure appearance, suitable for skincare and lifestyle advertising. Soft natural daylight, gentle green foliage background, shallow depth of field. The model is posed naturally, holding or interacting with the product in a realistic and harmonious way. Photorealistic, high resolution, professional commercial photography, clean and elegant composition.",
    path: "/assets/template/aiModel/aiModel_image_1.png",
  },
  {
    key: "ai_model_2",
    label: "AI 모델 2",
    prompt:
      "A healthy and energetic Asian female model with a bright, confident smile. She has a fit and athletic body, natural makeup, and long flowing hair. Sporty and active lifestyle appearance, suitable for fitness and wellness advertising. Outdoor tennis court environment, natural daylight, clean and fresh atmosphere. The model interacts naturally with the product in a realistic and balanced pose. Photorealistic, high resolution, professional commercial photography.",
    path: "/assets/template/aiModel/aiModel_image_2.png",
  },
  {
    key: "ai_model_3",
    label: "AI 모델 3",
    prompt:
      "A friendly Asian male barista with a warm smile and neat appearance. He is wearing a casual cafe uniform with an apron. Cozy coffee shop interior, wooden counter, warm ambient lighting. Natural and welcoming posture, interacting realistically with the product. Lifestyle food and beverage advertising style. Photorealistic, high resolution, professional commercial photography.",
    path: "/assets/template/aiModel/aiModel_image_3.png",
  },
  {
    key: "ai_model_4",
    label: "AI 모델 4",
    prompt:
      "A cheerful young Asian woman with a bright, joyful smile, enjoying Korean food. She has a cute and natural appearance with short wavy hair, wearing a simple and neat white blouse. She is holding chopsticks and happily eating spicy tteokbokki (or red spicy stew) with steam rising from the dish. Cozy home kitchen setting with blue tiled wall in the background, warm and inviting atmosphere. Table full of colorful Korean side dishes (banchan), grilled meat, fresh greens, and various small bowls. Lifestyle food advertising style, appetizing and mouth-watering composition. Photorealistic, high resolution, professional commercial food photography, natural lighting, vibrant colors.",
    path: "/assets/template/aiModel/aiModel_image_4.png",
  },
  {
    key: "ai_model_5",
    label: "AI 모델 5",
    prompt:
      "This high-quality commercial image combines realistic photography and flat illustration elements. At the center is a Korean woman in her early 20s, photographed from the waist up. She has straight hair with bangs and wears a simple pastel yellow top. Her eyes are wide open, her lips slightly parted, and her expression is a mixture of surprise and curiosity. One hand is placed near her mouth, as if responding to the product. Before her, the product is placed on a clean table, brightly lit and sharply focused. Surrounding the product are a rich array of colorful illustration elements, including stylish leaves, vegetables, flowers, and vibrant organic shapes. The illustration has a hand-drawn, flat feel, featuring bold outlines and vibrant colors. It seamlessly overlaps the actual product, leaving the model's face unobscured. The deep green background serves as a clean canvas on which the illustration elements can unfold. The lighting on the model and product is soft and even, maintaining a natural photographic feel, while the illustration graphics add a whimsical and vibrant contrast. The overall style is a premium lifestyle advertisement with a modern composition that harmoniously combines realism and illustration.",
    path: "/assets/template/aiModel/aiModel_image_5.png",
  },
  {
    key: "ai_model_6",
    label: "AI 모델 6",
    prompt:
      "A high-quality commercial photo featuring a Korean woman in her late 20s, positioned slightly to the left of the frame. She is leaning forward with her arms gently resting on the table edge, chin slightly lowered, creating a soft and intimate pose. Her expression is warm and playful with a subtle smile, eyes looking directly toward the camera, conveying approachability and curiosity. She wears a simple, casual light-gray top with a clean neckline, emphasizing a natural lifestyle look. Her hair is styled in a loose, slightly messy bun with soft strands framing her face, enhancing a relaxed and cozy mood. Makeup is minimal and natural, highlighting clear skin and gentle facial features. In front of her on the table is a neatly plated food item, placed slightly to the right, acting as a visual focal point without overpowering the model. A small dipping sauce or side element sits nearby, adding detail and realism. The camera angle is a medium close-up shot at eye level, with a shallow depth of field. The background is softly blurred, featuring warm indoor lighting and neutral tones, creating a calm, home-style atmosphere suitable for lifestyle food advertising. Soft, diffused light illuminates the model's face and the food evenly, producing a premium yet approachable commercial aesthetic.",
    path: "/assets/template/aiModel/aiModel_image_6.png",
  },
  {
    key: "ai_model_7",
    label: "AI 모델 7",
    prompt:
      "A high-impact commercial image with a deep navy-blue background, featuring a dynamic abstract tiger formed from flowing paint and liquid energy, blending orange and blue tones behind the model. A Korean male athlete in his early 30s stands confidently on the left, with a sharp jawline, short dark hair, and a calm yet powerful expression, wearing a modern dark jacket and holding the collar slightly with one hand. The tiger effect appears to emerge from behind and around the model, symbolizing strength, speed, and dominance, with dramatic motion and premium visual intensity. On the right side, a sleek product package is cleanly positioned, well-lit and sharply focused, balanced against the dynamic background, in a premium global advertising style.",
    path: "/assets/template/aiModel/aiModel_image_7.png",
  },
  {
    key: "ai_model_8",
    label: "AI 모델 8",
    prompt:
      "A high-quality commercial photo of three Korean adults in their late 20s to early 30s sitting together at an outdoor table. At the center, a cheerful Korean woman with long dark hair smiles brightly toward the camera, wearing a casual light-blue shirt, creating a friendly and approachable mood. The group is naturally interacting, holding drinks and reacting to the food on the table, expressing enjoyment and social connection. The background is a lush garden-style outdoor setting with natural daylight, softly blurred, while a variety of food items are placed across the table as generic product placeholders.",
    path: "/assets/template/aiModel/aiModel_image_8.png",
  },
  {
    key: "ai_model_9",
    label: "AI 모델 9",
    prompt:
      "This is a realistic advertisement photo, tilted slightly from the front and side. A Korean woman in her late 20s is leaning against a table, her elbows down and her hands resting lightly on her cheeks. Her lips are slightly parted, her expression a mixture of surprise and curiosity, as she gazes intently at the product. She wears a simple wristwatch on one wrist and has minimal, natural makeup. Her black hair is neatly tied back in a low ponytail, with a few strands framing her face. A clean tabletop displays the product neatly before her eyes. The background is a modern studio or kitchen, with muted colors, softly visible equipment, and diffused lighting that creates a natural advertising photoshoot atmosphere.",
    path: "/assets/template/aiModel/aiModel_image_9.png",
  },
  {
    key: "ai_model_10",
    label: "AI 모델 10",
    prompt:
      "This high-quality commercial portrait depicts a Korean man, presumably in his late 30s to early 40s (probable model: Shin Dong-yup). The photograph was taken against a dark, textured, dark gray studio background. His neatly styled short black hair is neatly brushed to the side, and he exudes a confident yet playful, sly smile and sharp gaze directed at the camera. The shot is taken from a frontal and side angle, with his face turned towards the camera. The photograph features a classic yet approachable look, paired with a subtly patterned long-sleeved shirt and red suspenders. He is seated or slightly leaning forward, holding a fork (or chopsticks) in one hand close to his face, as if about to savor the food, while supporting a bowl of food with the other. The lighting is dramatic yet restrained, creating soft highlights on his face and food, while subtle shadows add depth, creating a luxurious and powerful food advertising atmosphere.",
    path: "/assets/template/aiModel/aiModel_image_10.png",
  },
  {
    key: "ai_model_11",
    label: "AI 모델 11",
    prompt:
      "This photo depicts a Korean woman in her early 20s and a Korean man in his late 30s seated side by side at a red table. The woman on the left has long, wavy hair, bangs down, clear, fair skin, and subtle makeup that emphasizes her large eyes and glossy lips. She has a mole under her right eye. She wears a long-sleeved white knit top that reveals her shoulders, holds a can of soda close to her face, and smiles slightly toward the camera. The man on the right has naturally styled short black hair, clear skin, and a calm, relaxed expression. He wears a light gray hoodie, resting his chin on one hand and looking directly at the camera, leaning slightly forward in a relaxed posture. Between them is a bright red table neatly arranged with merchandise. The background is a warm and cozy interior with soft lighting, delicate decorations, and a shallow depth of field, creating an intimate lifestyle advertising atmosphere.",
    path: "/assets/template/aiModel/aiModel_image_11.png",
  },
  {
    key: "ai_model_12",
    label: "AI 모델 12",
    prompt:
      "The setting is a quiet, modern restaurant or lounge. A middle-aged Korean man with gray hair and glasses sits upright at a table, looking straight ahead. He wears a textured gray blazer over a dark shirt, holding a glass in one hand, and his expression is calm and thoughtful. His gaze is not directly at the camera, but slightly upward and forward, conveying a sense of deep thought and subtle tension. In the foreground, on the right side of the frame, a young Korean man, slightly out of focus, sits with his back to the camera. Only part of his face is visible in profile, and his gaze is directed toward the table, suggesting hesitation or inner conflict. He wears a dark suit jacket and has neatly trimmed short hair, highlighting the contrast between generations. On the table, products are neatly arranged between the two men, under soft lighting, preventing them from drawing too much attention. The warm, soft lighting, soft shadows, and shallow depth of field create an intimate, cinematic atmosphere with emotional weight. The background features subtle architectural textures and soft window light, further enhancing the understated, dramatic atmosphere.",
    path: "/assets/template/aiModel/aiModel_image_12.png",
  },
];

export default function Step3({ data = {}, updateData, onBack, onSubmit, image }) {
  const location = useLocation();
  const isRegen = location.state?.isRegen === true;

  const {
    age = "",
    channel = "",
    theme = "",
    style = "",
    aiModel = defaultAiModel,
  } = data;

  const firstAiModelKey = aiModelOptions[0]?.key || null;
  const currentAiModel = normalizeAiModel(aiModel);
  const isAiModelStyle = style === "AI 모델 합성";
  const styleValue = isAiModelStyle
    ? (currentAiModel.label ? `${style} · ${currentAiModel.label}` : style)
    : style;

  const [activeSheet, setActiveSheet] = useState(null);
  const [initializedByAI, setInitializedByAI] = useState(false);
  const [ensuredRequired, setEnsuredRequired] = useState(false);
  const [selectedBgKey, setSelectedBgKey] = useState(null);
  const [selectedFilterKey, setSelectedFilterKey] = useState(null);
  const [selectedAiModelKey, setSelectedAiModelKey] = useState(currentAiModel?.modelType || null);

  const aiAge = ageMap[localStorage.getItem("aiAge")] || "고객 연령";
  const aiTitle = themeMap[localStorage.getItem("aiTitle")] || "맞춤주제";
  const aiChannel = channelMap[localStorage.getItem("aiChannel")] || "채널 선택";
  const imagePreview = image?.imagePreview;
  const { showToast } = useToast();

  const [skipRegenPopup, setSkipRegenPopup] = useState(() => {
    if (!isRegen) return false;
    try {
      const v = localStorage.getItem("re_popup");
      return v === "true";
    } catch {
      return false;
    }
  });

  const [popupOpen, setPopupOpen] = useState(false);
  const [noPopup, setNoPopup] = useState(false);

  const normalizeAiModelForSave = (model) => {
    const merged = { ...defaultAiModel, ...(model || {}) };
    merged.enabled = Boolean(merged.enabled && merged.modelType);
    return merged;
  };

  const buildAiModelPayload = (modelKey) => {
    const selection = aiModelOptions.find((opt) => opt.key === modelKey) || null;
    if (!selection) return { ...defaultAiModel };
    return {
      enabled: true,
      modelType: selection.key,
      label: selection.label,
      prompt: selection.prompt,
      refImagePath: selection.path,
    };
  };

  const popupSubtitle = (
    <div className="space-y-1 text-b2">
      <p className="text-text-danger text-b2">* 이미지를 재생성할 경우 토큰이 차감됩니다.</p>
    </div>
  );

  const aiAgeValue = aiAge === "고객 연령" ? "" : aiAge;
  const aiTitleValue = aiTitle === "맞춤주제" ? "" : aiTitle;
  const aiChannelValue = aiChannel === "채널 선택" ? "" : aiChannel;

  const aiAutoPatch = useMemo(() => {
    const patch = {};
    if (!age) patch.age = aiAgeValue || "20대";
    if (!channel && aiChannelValue) patch.channel = aiChannelValue;
    if (!theme) patch.theme = aiTitleValue || "매장 홍보";
    if (!style) {
      patch.style = "원본 사용";
      patch.bg_prompt = "";
      patch.filter = "";
      patch.aiModel = { ...defaultAiModel };
    }
    return patch;
  }, [age, channel, theme, style, aiAgeValue, aiChannelValue, aiTitleValue]);

  const isAiApplied = Object.keys(aiAutoPatch).length === 0;

  const setField = (field, value) => {
    if (!updateData) return;
    if (field === "aiModel") {
      updateData({ aiModel: normalizeAiModel(value) });
      return;
    }
    updateData({ [field]: value });
  };

  const applyStyle = (nextStyle) => {
    setField("style", nextStyle);

    if (nextStyle !== "배경 AI 변경") {
      setSelectedBgKey(null);
      setField("bg_prompt", "");
    }
    if (nextStyle !== "이미지 필터") {
      setSelectedFilterKey(null);
      setField("filter", "");
    }
    if (nextStyle !== "AI 모델 합성") {
      setSelectedAiModelKey(null);
      setField("aiModel", { ...defaultAiModel });
    } else {
      const baseKey = selectedAiModelKey || firstAiModelKey;
      if (baseKey) {
        setSelectedAiModelKey(baseKey);
        setField("aiModel", normalizeAiModelForSave(buildAiModelPayload(baseKey)));
      }
    }
  };

  const canReset =
    !!channel ||
    !!style ||
    !!data.bg_prompt ||
    !!data.filter ||
    currentAiModel.enabled;

  const handleReset = () => {
    updateData?.({
      channel: "",
      style: "",
      bg_prompt: "",
      filter: "",
      aiModel: { ...defaultAiModel },
    });
    setActiveSheet(null);
    setInitializedByAI(true);
    setSelectedBgKey(null);
    setSelectedFilterKey(null);
    setSelectedAiModelKey(null);
    showToast("초기화되었습니다", {
      placement: "bottom",
      bottomOffset: "88px",
    });
  };

  const aiModelReady = !isAiModelStyle || (currentAiModel.enabled && currentAiModel.modelType);
  const canGoNext = !!(age && theme && channel && style && aiModelReady);

  const handleNext = async () => {
    if (!canGoNext) return;

    const userId = localStorage.getItem("user_id");
    if (noPopup && !skipRegenPopup && userId) {
      try {
        await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/re_popup`, {
          user_id: userId,
          re_popup: true,
        });
        localStorage.setItem("re_popup", "true");
        setSkipRegenPopup(true);
      } catch (err) {
        console.log("re_popup save error", err);
      }
    }

    onSubmit?.();
    setPopupOpen(false);
  };

  const handleRegenClick = () => {
    if (!canGoNext) return;

    if (!isRegen) {
      onSubmit?.();
      return;
    }

    if (skipRegenPopup) {
      handleNext();
      return;
    }

    setPopupOpen(true);
  };

  const handleAIAutoSelect = useCallback(() => {
    if (Object.keys(aiAutoPatch).length === 0) return;
    updateData?.({ ...aiAutoPatch });
  }, [aiAutoPatch, updateData]);

  useEffect(() => {
    if (initializedByAI) return;
    const hasUserSelection = !!channel || !!style;
    const hasAI = !!aiChannelValue;

    if (!hasUserSelection && hasAI && !isAiApplied) {
      handleAIAutoSelect();
      setInitializedByAI(true);
    }
  }, [initializedByAI, channel, style, aiChannelValue, isAiApplied, handleAIAutoSelect]);

  useEffect(() => {
    if (ensuredRequired) return;
    const nextAge = age || aiAgeValue || "20대";
    const nextTheme = theme || aiTitleValue || "매장 홍보";
    if (!age) setField("age", nextAge);
    if (!theme) setField("theme", nextTheme);
    setEnsuredRequired(true);
  }, [ensuredRequired, age, theme, aiAgeValue, aiTitleValue]);

  useEffect(() => {
    if (!style) return;
    if (style === "배경 AI 변경" && selectedBgKey && BgPrompts[selectedBgKey]) {
      setField("bg_prompt", BgPrompts[selectedBgKey]);
    }
  }, [style, selectedBgKey]);

  return (
    <div className="relative flex h-dvh min-h-dvh flex-col overflow-hidden bg-surface-default">
      <HeaderIconLActionR
        title=""
        actionText="초기화"
        onAction={canReset ? handleReset : undefined}
        icon={arrowleft}
        onIconClick={onBack}
      />

      <div
        className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-[16px] [touch-action:pan-y] [-webkit-overflow-scrolling:touch]"
        style={{ paddingBottom: "24px" }}
      >
        <div className="flex items-center justify-between pb-[32px]">
          <h2 className="text-t2">옵션 설정</h2>
          <Chip
            chip="d"
            label="AI 자동 선택"
            status="selected"
            onClick={() => {
              if (isAiApplied) {
                showToast("이미 선택되어 있습니다", {
                  placement: "bottom",
                  bottomOffset: "88px",
                });
              } else {
                handleAIAutoSelect();
              }
            }}
          />
        </div>

        <div className="flex flex-col gap-[16px]">
          <SelectCard
            label="홍보 채널"
            value={channel}
            placeholder="채널 선택"
            onClick={() => setActiveSheet("channel")}
          />

          <div className="w-full">
            <p className="text-t2 text-text-subtle pb-[8px]">이미지 스타일</p>
            <div className="text-b2 text-text-subtle pb-[12px]">
              <p>어떤 스타일로 변경하고 싶은지 원하는 스타일을 선택해 주세요.</p>
              <p>업로드한 이미지와 잘 어울리는 스타일을 선택해야 결과가 안정적으로 나옵니다.</p>
            </div>

            <div className="overflow-x-auto">
              <div className="flex gap-2 min-w-max">
                {STYLE_OPTIONS.map((opt) => (
                  <Chip
                    key={opt}
                    chip="d"
                    label={opt}
                    status={style === opt ? "selected" : "default"}
                    onClick={() => applyStyle(opt)}
                  />
                ))}
              </div>
            </div>

            {style === "원본 사용" && (
              <div className="pt-[12px]">
                <div className="relative w-full">
                  <div className="absolute top-[16px] left-1/2 -translate-x-1/2 z-10">
                    <Chip chip="e" label="원본 예시" />
                  </div>
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="원본 사용 예시"
                      className="w-full max-h-[480px] object-contain rounded-[12px] border-2 border-border-primary"
                      draggable={false}
                    />
                  ) : (
                    <div className="w-full min-h-[240px] rounded-[12px] border border-border-subtle flex items-center justify-center text-b1 text-text-subtler">
                      원본 이미지가 없습니다.
                    </div>
                  )}
                </div>
              </div>
            )}

            {style === "배경 AI 변경" && (
              <div className="pt-[12px]">
                <p className="text-b2 text-text-subtle pb-[8px]">배경 예시</p>
                <div className="grid grid-cols-2 gap-[8px]">
                  {bgOptions.map((it) => {
                    const selected = selectedBgKey === it.key;
                    return (
                      <div key={it.key} className="relative flex flex-col items-center w-full">
                        <button
                          type="button"
                          onClick={() => {
                            applyStyle("배경 AI 변경");
                            setSelectedBgKey(it.key);
                            setField("bg_prompt", BgPrompts[it.key] ?? "");
                          }}
                          className={
                            "relative w-full aspect-square rounded-[12px] overflow-hidden border-[2px] " +
                            (selected ? "border-border-primary" : "border-transparent")
                          }
                        >
                          <img
                            src={it.image}
                            alt={it.label}
                            className="w-full h-full object-cover"
                            draggable={false}
                          />

                          {selectedBgKey && !selected && (
                            <div className="absolute inset-0 bg-surface-white-dimmed_80 pointer-events-none" />
                          )}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {style === "이미지 필터" && (
              <div className="pt-[12px]">
                <p className="text-b2 text-text-subtle pb-[8px]">필터 선택</p>
                <div className="grid grid-cols-2 gap-[8px]">
                  {fiOptions.map((it) => {
                    const selected = selectedFilterKey === it.key;
                    return (
                      <div key={it.key} className="relative flex flex-col items-center w-full">
                        <button
                          type="button"
                          onClick={() => {
                            applyStyle("이미지 필터");
                            setSelectedFilterKey(it.key);
                            setField("filter", it.key);
                          }}
                          className={
                            "relative w-full aspect-square rounded-[12px] overflow-hidden border-[2px] " +
                            (selected ? "border-border-primary" : "border-transparent")
                          }
                        >
                          <img
                            src={it.image}
                            alt={it.label}
                            className="w-full h-full object-cover"
                            draggable={false}
                          />

                          {selectedFilterKey !== null && !selected && (
                            <div className="absolute inset-0 bg-surface-white-dimmed_80 pointer-events-none" />
                          )}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {style === "AI 모델 합성" && (
              <div className="pt-[12px]">
                <p className="text-b2 text-text-subtle pb-[8px]">AI 모델 선택</p>
                <div className="grid grid-cols-2 gap-[8px]">
                  {aiModelOptions.map((it) => {
                    const selected = selectedAiModelKey === it.key;
                    return (
                      <div key={it.key} className="relative flex flex-col items-center w-full">
                        <button
                          type="button"
                          onClick={() => {
                            applyStyle("AI 모델 합성");
                            setSelectedAiModelKey(it.key);
                            setField("aiModel", normalizeAiModelForSave(buildAiModelPayload(it.key)));
                          }}
                          className={
                            "relative w-full aspect-square rounded-[12px] overflow-hidden border-[2px] transition " +
                            (selected ? "border-border-primary" : "border-transparent")
                          }
                        >
                          <img
                            src={it.path}
                            alt={it.label}
                            className="w-full h-full object-cover"
                            draggable={false}
                          />

                          {selectedAiModelKey && !selected && (
                            <div className="absolute inset-0 bg-surface-white-dimmed_80 pointer-events-none" />
                          )}
                        </button>
                      </div>
                    );
                  })}
                </div>

                <div className="pt-[12px]">
                  <p className="text-b2 text-text-subtle">현재 선택</p>
                  <p className="text-b1 text-text-default pt-[4px]">{styleValue || ""}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="shrink-0 border-t border-border-subtle bg-surface-default/95 backdrop-blur-[8px]"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <SingleButton type="fill" disabled={!canGoNext} onClick={handleRegenClick}>
          이미지 생성하기
        </SingleButton>
      </div>

      <ChanneSelectSheet
        isOpen={activeSheet === "channel"}
        onClose={() => setActiveSheet(null)}
        value={channel}
        onSelect={(opt) => setField("channel", opt)}
        height="h-[702px]"
      />

      <Popup
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        title="다시 생성하기"
        subtitle={popupSubtitle}
        renderButtons={
          <>
            <button
              type="button"
              className="flex items-center p-[24px] pb-[16px]"
              onClick={() => setNoPopup((prev) => !prev)}
            >
              <img src={noPopup ? checkOn : checkOff} alt="" className="pr-[8px]" />
              <span className="text-b1 text-text-default">다시 보지 않기</span>
            </button>
            <TwinColumn
              topType="fill"
              topText="다시 생성하기"
              onTop={handleNext}
              bottomType="empty"
              bottomText="취소"
              onBottom={() => setPopupOpen(false)}
            />
          </>
        }
      />
    </div>
  );
}
